import { SalesChannelStatus } from '@/src/types/common/SalesChannel';
import { modal } from '@/src/utils/Modal';
const useSalesChannelSubmit = ({
  isValid,
  submit,
  status,
  avoidSubmitWhenHasError,
  getI18n,
}) => {
  if (avoidSubmitWhenHasError) {
    submit();
    return;
  }
  if (!isValid) {
    if (status === SalesChannelStatus.draft) {
      modal.error({
        onCancel: () => {
          return;
        },
        onOk: submit,
        title: 'Warning',
        okText: 'Continue editing',
        content: getI18n('general.draftVersionWarning'),
      });
    }
    if (status === SalesChannelStatus.scheduled) {
      modal.error({
        onCancel: () => {
          return;
        },
        onOk: () => {
          return;
        },
        okText: 'Continue editing',
        title: 'Unable to save changes',
        content: getI18n('general.fixErrorsBeforeSave'),
      });
    }
    if (status === SalesChannelStatus.live) {
      modal.error({
        onCancel: () => {
          return;
        },
        onOk: () => {
          return;
        },
        okText: 'Continue editing',
        title: 'Unable to save changes',
        content: getI18n('general.fixErrorsBeforeSave'),
      });
    }
  } else {
    submit();
  }
};
export { useSalesChannelSubmit };
